import { useAtomValue } from 'jotai'
import { Button, IconArrowInbox } from '@sequencehq/core-components'
import { customersFiltersApiQueryParamsAtom } from 'modules/Customers/customers.atoms'
import { useCustomersCsvExport } from 'modules/Customers/hooks/useCustomersCsvExport'

export const CustomersExportToCsv = () => {
  const filtersApiQueryParams = useAtomValue(customersFiltersApiQueryParamsAtom)

  const { download } = useCustomersCsvExport()

  const buttonProps = {
    variant: 'secondary',
    leadingIcon: <IconArrowInbox color="initial" />,
    'data-testid': 'customers.exportToCsv'
  } as const

  if (!download.available) {
    return null
  }

  return (
    <Button
      {...buttonProps}
      onClick={() =>
        download.onClick(new URLSearchParams(filtersApiQueryParams))
      }
    >
      Export to CSV
    </Button>
  )
}
